import Logo from '../../assets/Nav.png'
import styles from './NavBar.module.css';
import { Link } from 'react-router-dom';

function Navbar(){
        return <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-primary ps-3 pe-3">
  
  <div className="container-fluid">
      <a className="navbar-brand" href="https://interambiental.com.br" target="_blank">
          <img className="mb-2" src={Logo} alt="Imagem" style={{ height: "40px", margin: "0.5px" }}/>
      </a>
      <ul   className={styles.list}>
            <li className={styles.item}> 
                    <Link to='/Home'> <i className="fas fa-home"></i>Inicio</Link> 
            </li>
            <li className={styles.item} > 
                    <Link to='/Documentos'><i className="fas fa-id-card"></i>Documentos</Link>
            </li>
            <li className={styles.item}> 
                    <Link to='/programacao'> <i className="fas fa-calendar-day"></i>Programação</Link>
            </li>
            <li className={styles.item}> 
                    <Link to='/monitoramento'><i className="fas fa-list"></i>Monitoramentos</Link> 
            </li>
            <li className={styles.item}> 
                    <Link to='/Grafico'><i className="fas fa-chart-line"></i>Gráficos</Link>
            </li>
            <li className={styles.item}> 
                    <Link to='/Imagem'><i className="fas fa-camera"></i>Fotos</Link>
            </li>
            <li className={styles.item}> 
                    <Link to='/Financeiro'><i className="fas fa-coins"></i>Financeiro</Link>
            </li >
    </ul>
      
     

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <div className="btn-group">
                
              <button type="button" className="btn btn-outline-light me-4 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <i className="fas fa-user"></i> Sobre a Empresa
              </button>
              <ul className="dropdown-menu dropdown-menu-end">                    
                  <li className={styles.itemH}> 
                     <Link to='/Certificado'>Certificados e licenças</Link>
                  </li>
                  <li className={styles.itemH}> 
                     <Link to='/News'>News</Link>
                  </li >

                  <li><hr className="dropdown-divider" /></li>
                
                  <li className={styles.itemH}> 
                        <Link to='/'>Sair</Link>
                  </li>
               </ul>
          </div>
      </div>
   
  </div>

</nav>
}

export default Navbar;